<template>
  <!-- 研究 -->
  <div class="page-research">
    <div class="g-banner">
      <cmpBanner bannerType="5"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>
    <div class="g-content-wrap g-pad-top" :class="{ 'knowledge': activeVal == 6 }">
      <cmpSubTab ref="cmpSubTab" :tabs="subTabList" :activeVal="activeSubVal" v-if="activeVal === '5'"
        @eventTabClick="eventSubTabClick"></cmpSubTab>

      <div :class="{ 'g-pad-bottom-2': activeVal != 6 }">
        <!-- 科研课题、学术论文 -->
        <div class="list-box list4" v-if="activeVal === '1' || activeVal === '4'">
          <div class="child g-pointer" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
            <div class="info">
              <p class="title ell m-font-2">{{ item.title }}</p>
              <span class="m-font-2" v-if="activeVal === '4'">{{
                item.publishTime
              }}</span>
            </div>
            <p class="author mt-10 m-font-4">{{ item.author }}</p>
          </div>
        </div>

        <!-- 学术会议、精品图录 -->
        <div class="list1 g-card-list" v-if="activeVal === '2' || activeVal === '3'">
          <div class="item g-card-1" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
            <div class="pic-box">
              <img v-lazy="item.img" alt="" />
            </div>
            <div class="info">
              <div>
                <h2 style="margin-bottom: 5px">{{ item.title }}</h2>
                <p class="time ell" v-if="activeVal === '2'">
                  会议时间｜{{ item.publishTime }}
                </p>
                <p class="time ell" v-if="activeVal === '3'">
                  {{ item.author }}｜{{ item.publishTime }}
                </p>
              </div>
              <div class="intro mt-10 ell">{{ item.summary }}</div>
            </div>
          </div>
        </div>

        <!-- 辽博讲堂 -->
        <div class="list2 g-card-list" v-if="activeVal === '5'">
          <div class="item g-card-1" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
            <div class="pic-box">
              <img v-lazy="item.pic" alt="" />
              <!-- <div class="name-fl">精品</div> -->
              <div class="icon-play" v-show="activeSubVal === '2'"></div>
              <!-- <div class="icon-play" @click="goDetailVideo(item)"></div> -->
            </div>
            <div class="info">
              <h2 class="m-font-2" style="margin-bottom: 18px">
                {{ item.title }}
              </h2>
              <p class="time">{{ item.speaker }}</p>
              <p class="time time2">{{ item.time }}</p>
              <p class="intro mt-10 two-ell m-font-4">{{ item.address }}</p>
            </div>
          </div>
        </div>

        <div class="h-100" v-if="activeVal === '6'">
          <Knowledge></Knowledge>
        </div>


        <!-- 无数据 -->
        <div class="g-no-data" v-if="dataList.length === 0 && !listLoading && activeVal != 6">
          <div class="no-data-bg"></div>
          <p class="txt text-center">暂无数据</p>
        </div>
      </div>

      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total"
        @eventPage="eventPage"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
import cmpSubTab from '@cmp/tab/sub-tab'
import Knowledge from './knowledge.vue'
export default {
  components: { cmpTab, cmpSubTab, Knowledge },
  data() {
    return {
      activeVal: this.$route.query.pageType || '6',
      tabList: [
        // {
        //   name: '知识图谱',
        //   val: '6'
        // },
        {
          name: '精品图录',
          val: '3'
        },
        {
          name: '辽博讲堂',
          val: '5'
        },
        {
          name: '科研课题',
          val: '1'
        },
        {
          name: '学术会议',
          val: '2'
        },
        {
          name: '学术论文',
          val: '4'
        }
      ],
      activeSubVal: '2',
      subTabList: [
        {
          name: '讲座预告',
          val: '1'
        },
        {
          name: '往期回顾',
          val: '2'
        }
      ],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 9
      },
      total: 0,
      listLoading: false
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.pageType != from.query.pageType) {
        this.activeVal = to.query.pageType || '1'
        if (this.activeVal === '5') {
          this.getClassDataList()
        } else {
          this.getDataList()
        }
      }
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/applet/science/list', {
          ...this.listQuery,
          type: this.activeVal
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getClassDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/applet/classRoom/list', {
          ...this.listQuery,
          type: this.activeSubVal
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.result
            // this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
    eventTabClick(val) {
      console.log(val)
      this.activeVal = val
      this.listQuery.currentPage = 1

      if (this.activeVal === '5') {
        this.getClassDataList()
      } else {
        this.getDataList()
      }
    },
    eventSubTabClick(val) {
      this.activeSubVal = val
      this.listQuery.currentPage = 1
      this.getClassDataList()
    },
    goDetail(item) {
      if (this.activeVal === '4' && item.fileIds) {
        let pdfUrl = item.fileList && item.fileList[0].attPath
        window.open(pdfUrl, '_blank')
        return
      }
      this.$router.push({
        path: '/research/detail',
        query: { id: item.id, pageType: this.activeVal }
      })
      // if(this.activeVal === '3' || this.activeVal === '4') {
      //   this.$router.push({
      //     path: '/research/detail',
      //     query: {id: item.id, pageType: this.activeVal}
      //   })
      // } else {
      //   this.$router.push({
      //     path: '/alliance/detail',
      //     query: {id: item.id}
      //   })
      // }
    }
  },
  created() {
    if (this.activeVal === '5') {
      this.getClassDataList()
    } else {
      if (this.activeVal != 6) {
        this.getDataList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-research {
  .knowledge {
    margin: 0;
    padding: 0;
  }

  .list3 {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 49%;

      &:not(:nth-child(2n)) {
        margin-right: 2%;
      }

      .pic-box {
        width: 230px;
        height: 300px;
        background: $primary;
        padding: 10px;
        box-sizing: border-box;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .info {
        .desc {
          height: 110px;
          overflow: hidden;
        }
      }
    }
  }

  .list4 {
    margin-bottom: 30px;
    position: relative;
    font-size: 14px;
    line-height: 24px;
    color: #595452;

    .child {
      position: relative;
      padding: 30px;
      padding-right: 0;
      border-bottom: solid 1px rgba(#312f2e, 0.2);
      font-size: 24px;
      color: #000000;

      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:before {
          content: '';
          display: block;
          width: 16px;
          height: 16px;
          border: solid 1px $primary;
          border-radius: 100%;
          position: absolute;
        }

        &:before {
          left: 0;
          top: 32px;
        }

        p {
          width: 1200px;
        }
      }

      .author {
        margin-top: 14px;
        color: rgba($color: #000000, $alpha: 0.7);
        // font-size: 14px;
      }

      &:first-child {
        border-top: solid 1px $primary;
      }

      &:last-child {
        border-color: $primary;
      }

      &:hover {
        .title {
          color: $primary;
        }
      }
    }
  }

  .list1 {
    .item {
      .pic-box {
        img {
          height: 288px;
        }
      }

      .info {
        h2 {
          display: inline-block;
          max-width: 100%;
          border-bottom: solid 1px transparent;
        }
      }

      &:hover {
        .info {
          h2 {
            border-bottom: solid 1px #000000;
          }
        }
      }
    }
  }

  .list2 {
    .info {
      .time2 {
        color: $primary;
        margin-top: 5px;
      }
    }
  }

  .g-card-1 .info .intro {
    opacity: 0.7;
  }
}
</style>
